import * as React from "react";
function SvgIcClear(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.685 5.397A8.292 8.292 0 0112.292 4a8.301 8.301 0 018.291 8.291A8.292 8.292 0 117.685 5.397zm.417 13.165a7.541 7.541 0 004.19 1.271 7.55 7.55 0 007.541-7.542 7.542 7.542 0 10-11.731 6.271z"
        fill="currentColor"
      />
      <path
        d="M15.614 8.453l-3.315 3.315-3.3-3.3-.53.531 3.3 3.3-3.284 3.283.53.53 3.284-3.283 3.299 3.3.53-.532-3.3-3.299 3.316-3.315-.53-.53z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcClear;
